export default{
  detalhes: {
    value: null,
    maxlength: '500',
    rows: 5,
    required: true,
    state: null,
    noResize: false
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/observation/observation-form.js